import React, { useEffect, useState } from "react";
import useGlobal from "../../store";
import { getSiteEquipment, getAllEquipment, getSpaceEquipment, getBuildingEquipment } from "../../services/MetadataService";

import { useHistory } from "react-router-dom";
import EquipmentList from "../../components/EquipmentList";

const EquipmentResultList = (props) => {
    const [equipment, setEquipment] = useState()
    const[location, setLocation] = useState('Equipment')
    let [currentState, currentActions] = useGlobal();
    let history = useHistory();

    useEffect(() => {
        if (!equipment) {
            if (props.spaceId) {
                getSpaceEquipment(props.spaceId).then(response => {
                    setEquipment(response)
                })
            } else if (props.zoneId) {

            } else if (props.buildingId) {
                getBuildingEquipment(props.buildingId).then(response => {
                    setEquipment(response)
                })
            } else if (props.siteId) {
                getSiteEquipment(props.siteId).then(response => {
                   setEquipment(response)
                })
            }
        }
    }, [])

    useEffect(() => {
        if (currentState.currentModule !==  location) {
            currentActions.setCurrentModule(location)
        }
    },[location])
    
    return <div className="layer3">
            <EquipmentList equipment={equipment} siteId={props.siteId} buildingId={props.buildingId} spaceId={props.spaceId} zoneId={props.zoneId} />
        </div>

}

export default EquipmentResultList;